<!-- 个人中心 -->
<template>
  <div class="personal-wp">
    <!--个人中心-->
    <div class="bar_name">
      <!--简介-->
      <div class="name_img clear">
        <div @click="$router.push('/home/authInfor')">
          <img v-if="getUserInforAjax.user" :src="getUserInforAjax.user.avatar" alt="">
        </div>
        <div @click="$router.push('/home/authInfor')">
          <div class="myname">
            <p v-if="getUserInforAjax.user">{{getUserInforAjax.user.nickname}} <span class="my-age">{{getUserInforAjax.gender == 2 ? '女' : '男'}} {{getUserInforAjax.birthdayText}}</span></p>
            <p><i class="iconfont icon-xingcheng"></i>{{getUserInforAjax.user.homeCity.province.label || '未设置家乡'}}-{{getUserInforAjax.user.hometown.province.label}}-{{getUserInforAjax.user.hometown.province.label}}</p>
            <p><span>情感状态：{{getUserInforAjax.user.emotion}}</span></p>
            <p>职业：{{getUserInforAjax.user.job || '未设置'}}</p>
          </div>
        </div>
      </div>
      <!--资金-->
      <!-- <img src="../../../static/images/home/nameBg.jpg" height="auto" width="100%" /> -->
      <div class="name_money clear" style="display:none">
        <div>
          <div>
            <span class="personal-money-tip">余额 &yen; </span>
            <span class="personal-money">0</span>
          </div>
          <div>
            <span class="personal-money-tip">基金 &yen; </span>
            <span class="personal-money">0</span>
          </div>
          <!-- <span class="personal-money-btn rt">现在提现</span> -->
          <!--<span class="personal-money-btm-tip">（满<span style="color: #f60;">&yen;100</span>即可提现）</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from 'api/api'
import $ from "jquery";
export default {
  data () {
    return {
      getUserInforAjax: {}, //首页个人信息
      UserAccoun: ''
    }
  },
  mounted () {
    // 获取个人信息
    http.GET('/jw-function', {
      module: 'home',
      operation: 'getUserHome',
      uid: localStorage.getItem('pbw_user_pc_uid'),
    }).then((res) => {
      this.getUserInforAjax = res
    })


    // 获取资产
    // selectUserAccoun({
    //   uid: localStorage.getItem('pbw_user_pc_uid')
    // }).then((res) => {
    //   if (res.code == '000000') {
    //     vm.UserAccoun = res.data
    //   } else {
    //     vm.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
    //   }
    // })
  }
}
</script>

<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
.personal-wp {
  .name_img {
    width: 100%;
  }
  .name_img > div {
    display: flex;
    align-items: center;
    float: left;
    height: 130px;
    padding: 10px;
  }
  .name_img img {
    width: 130px;
    height: 130px;
  }
  .personal-money-tip {
    font-size: 24px;
  }
  .personal-money {
    font-size: 56px;
    font-weight: bold;
  }
  .personal-money-btn {
    color: #fff !important;
    background: #698adb;
    padding: 16px 50px;
    border-radius: 10px;
    font-size: 18px;
    margin-top: 20px;
  }
  .personal-money-btm-tip {
    color: #999 !important;
    float: right;
    margin-top: -20px;
    margin-right: 30px;
  }
  .personal-money-one {
    color: #fff !important;
    background: #698adb;
    padding: 6px 30px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 24px;
  }
  .personal-money-two {
    color: #fff !important;
    background: #26b3f4;
    padding: 6px 30px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 24px;
    margin-right: 20px;
  }
  .myname p {
    padding: 5px;
  }
  .myname > p:first-child {
    font-size: 16px;
    font-weight: bold;
  }
  .my-age {
    color: #f60;
    border: 1px solid #f60;
    padding: 0px 8px;
    font-size: 12px;
    border-radius: 50px;
    margin-left: 10px;
  }
  .icon-xingcheng {
    color: #f60;
    padding-right: 4px;
  }
  .name_money {
    padding: 20px 80px;
    border: 1px solid #d5d5d5;
    span {
      color: #f60;
    }
    > div {
      display: flex;
      justify-content: space-around;
    }
  }
  .name_money span {
    color: #f60;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/personal.vue